/**
 * Revocation reason codes (RFC 5280 CRLReason, which is what the issuer portal
 * offers when revoking).
 *
 * The stored value is the bare code, so anything that displays a revocation —
 * the issuer's history table and the holder's credential details — must map it
 * back to a label. Holders in particular should never be shown a raw "01".
 *
 * Kept here rather than in a locale file because the holder and issuer pages
 * load different i18n namespaces; this is shared by both.
 */
export const REVOCATION_REASONS: Record<string, string> = {
  '01': 'Unspecified',
  '02': 'Key Compromise',
  '03': 'CA Compromise',
  '04': 'Affiliation Changed',
  '05': 'Superseded',
  '06': 'Cessation of Operation',
  '07': 'Certificate Hold',
  '08': 'Privilege Withdrawn',
  '09': 'AA Compromise',
};

/**
 * Render a stored revocation reason for display: "01" becomes
 * "01 - Unspecified". A free-text reason (issued via the API rather than the
 * portal's dropdown) is returned unchanged.
 */
export function formatRevocationReason(reason?: string): string {
  if (!reason) return '';
  const label = REVOCATION_REASONS[reason.trim()];
  return label ? `${reason.trim()} - ${label}` : reason;
}
